/*
 * @Author: yukizou yukizou@tencent.com
 * @Date: 2025-07-30 19:26:06
 * @LastEditors: yukizou yukizou@tencent.com
 * @LastEditTime: 2025-08-05 20:24:34
 */
import { AjaxConfig } from '@tencent/wsl-ajax';
import { TRPC_CALL_PATH, TRPC_CALL_TEST_PATH } from '@/constants/url';
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { getReqHeader } from '@/utils/request';
import { checkIsTestEnvAndInBrowser } from '@/utils/env';
import { HotDramas, FetchHotDramasRsp, DramaFeeds, FetchDramaFeedsRsp } from '@/types/services/fetch-hot-drama';

const getUrl = () => (checkIsTestEnvAndInBrowser() ? TRPC_CALL_TEST_PATH : TRPC_CALL_PATH);

/**
 *
 * 获取推荐短剧
 * @export
 * @param
 * @return {*}  {(Promise<FetchResult | null>)}
 */
export async function fetchHotDramas(): Promise<HotDramas | null> {
  const fetchConfig: AjaxConfig = {
    url: `${getUrl()}/GetDailyHotDramas`,
    withCredentials: true,
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    responseType: 'json',
    data: JSON.stringify({
      req_body: {
        source: 'wesee_share_h5_hot_dramas',
        daily: 7, // 默认推荐 7 天内的
        attach: '', // 翻页透传数据，此处首页数据即可满足，传空
      },
      req_header: getReqHeader(),
    }),
  };
  try {
    const wslAjax = await loadWslAjaxAsync();
    if (!wslAjax) return null;
    const { request } = wslAjax;
    const res = await request<FetchHotDramasRsp>(fetchConfig);

    if (res) {
      return {
        attach: res.rsp_body?.attach,
        dramas: res.rsp_body?.dramas,
      };
    };
  } catch (err) {
    console.error('接口 fetchDailyHotDramas 出现了一些问题');
  };
  return null;
}

/**
 *
 * 获取短剧详情
 * @export
 * @param
 * @return {*}  {(Promise<FetchResult>)}
 */
export async function fetchDramaFeed(params: {
  dramaID: string;
}): Promise<DramaFeeds | null> {
  const fetchConfig: AjaxConfig = {
    url: `${getUrl()}/GetDramaFeeds`,
    withCredentials: true,
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    responseType: 'json',
    data: JSON.stringify({
      req_body: {
        dramaID: params.dramaID,
        refresh: 0,
        attach: '', // 翻页透传数据，此处首页数据即可满足，传空
      },
      req_header: getReqHeader(),
    }),
  };
  try {
    const wslAjax = await loadWslAjaxAsync();
    if (!wslAjax) return null;
    const { request } = wslAjax;
    const res = await request<FetchDramaFeedsRsp>(fetchConfig);

    if (res) {
      return {
        attachInfo: res.rsp_body?.attachInfo,
        drama: res.rsp_body?.drama,
        dramaFeeds: res.rsp_body?.dramaFeeds,
      };
    };
  } catch (err) {
    console.error('接口 fetchDailyHotDramas 出现了一些问题');
  };
  return null;
}
